module.exports = __webpack_public_path__ + "static/img/image_c_mango.b9e71d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_c_mango.jpg
// module id = ThLn
// module chunks = 1